import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DashboardPlusicon } from '../../../Icons/DashboardPlusicon';
import * as _ser from '../../../_redux/_services/ApplicantsSlice';
import * as _sercloud from '../../../_redux/_services/CloudSourcingSlice';
import { customFieldsAsync } from '../../../_redux/_services/UserManagerSlice';
import GetJobId from '../../../_utilities/GetJobId';
import { GetTimeZone } from '../../../_utilities/GetTimeZone';
import {
  getCandidateInternalStatus,
  getCandidateStatusCustomValues,
} from '../../../_utilities/internalexternalhelper';
import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import AddApplicantAssociatedJobs from './AddApplicantAssociatedJobs';
import './ApplicantAssociatedJobs.css';

import { GetUserId } from '../../../_utilities/getUserInfo';
const initalState = { data: null, message: '', isloader: true };

const ApplicantAssociatedApplicants = () => {
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);

  const [showTable, setShowTable] = useState(false);
  const [AccociatedJobSeekerList, setAccociatedJobSeekerList] = useState([]);
  const [qnsCount, setQnsCount] = useState(0);
  const [showJobDetails, setShowJobDetails] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const [getData, setGetData] = useState('');
  const [questionsData, setQuestionsData] = useState([]);
  const [config, setConfig] = useState(configuration);
  const getJobCode = GetJobId();
  const dispatch = useDispatch();
  const [componentType, setComponentType] = useState('AssociatedJobs');
  const [isValidUser, setIsValidUser] = useState(false);
  const [pannelobj, setPannelobj] = useState({
    title: '',
    description: '',
    bgImage: '',
    navigateTo: '',
  });
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);

  const nextPathValue = useSelector((state) => state.SeletedNextPath.value);
  const navigate = useNavigate();
  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    if (getJobCode !== null) {
      FetchData();
    }
    // eslint-disable-next-line
  }, [getJobCode]);

  useEffect(() => {
    if (nextPathValue === 'null') {
      setShowJobDetails(false);
      localStorage.setItem('AssociatedMenu', 'false');
      window.dispatchEvent(new Event('storage'));
    }
  }, [nextPathValue]);

  const GetApplicantJobsData = useSelector(
    (state) => state.GetApplicantJobs.data
  );
  const GetApplicantJobsCode = useSelector(
    (state) => state.GetApplicantJobs.code
  );

  useEffect(() => {
    if (GetApplicantJobsCode === 404) {
      setIsValidUser(true);
    }
  }, [GetApplicantJobsCode]);

  const FetchData = async () => {
    setAccociatedJobSeekerList([]);
    dispatch(_ser.getApplicantJobsAsync(getJobCode));
  };

  useEffect(() => {
    const init = async () => {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    };
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const array = getCandidateStatusCustomValues(customFieldsData);
      setCandidateStatusValues(array);
    }
  }, [customFieldsData]);

  useEffect(() => {
    if (GetApplicantJobsData?.length && candidateStatusValues.length) {
      let myData = JSON.parse(JSON.stringify(GetApplicantJobsData));
      let newArray = [];
      myData.forEach((e, i) => {
        e['percentage'] =
          e.matchPercentage !== -1
            ? Math.round(e.matchPercentage * 100)
            : 'N/A';
        e['lastUpdated'] = GetTimeZone(e.lastUpdated);
        e['isChecked'] = false;
        if (candidateStatusValues.length) {
          e.status = getCandidateInternalStatus(
            e.status,
            candidateStatusValues
          );
        }
        e['id'] = i + 1;
        if (
          e.sourcedFrom === 'Cloudsourcing' ||
          e.sourcedFrom === 'Employee Portal'
        ) {
          e['screeningquestions'] = `${e.anscount}/${e.qnscount}`;
        } else {
          e['screeningquestions'] = '';
        }
        newArray.push(e);
      });
      setAccociatedJobSeekerList(newArray);
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = newArray.length;
      configure.currentPage = 1;
      setConfig(configure);
      setComponentType('AssociatedJobs');
      dispatch(_ser.getApplicantJobsStartReducer(initalState));
    }
  }, [candidateStatusValues, GetApplicantJobsData]);

  const onReceiveActionHandler = async (type, object) => {
    setShowTable(false);
    if (type === 'pagination') {
      FetchData(object);
    } else if (type === 'searchResult') {
    } else if (type === 'cancelSearchResult') {
      setFilterValue('');
      let obj1 = {
        current: config.currentPage,
        offset:
          config.currentPage !== 1
            ? (config.currentPage - 1) * 20 + 1
            : config.currentPage,
      };
      FetchData(obj1);
    } else if (type === 'confirmDel') {
      DeleteRecords(object);
    } else if (type === 'detailspage') {
      setIsRightSidePannel(true);
      setComponentType('jobProfile');
      let obj = {
        jobopeningID: object.jobopeningID,
        asscoId: object.asscoId,
        status: object.status,
      };
      setGetData(obj);
      console.log(object.jobopeningID);
      setPannelobj({
        ...pannelobj,
        title: `${object.jobTitle} (${object.jobCode})`,
        navigateTo: `/ats/layout/jobpostings/view/${object.jobopeningID}`,
      });
      // sessionStorage.setItem("AssociatedId", object.jobopeningID);
      // dispatch(updateNextPath(object.jobTitle));

      // setShowJobDetails(true);
      //   navigate(`/ats/layout/applicants/associatedjobs/jobview/${getJobCode}`, {
      //     state: { object }
      // });
      //   sessionStorage.setItem("actualId", getJobCode);
      //   localStorage.setItem("AssociatedMenu", object.jobTitle);
      //   window.dispatchEvent(new Event('storage'))
    } else if (type === 'viewAnswers') {
      let Obj = {
        cs_id: object.cs_id,
        job_id: object.jobopeningID,
        applicant_id: object.applicantID, //TODO
      };
      dispatch(_sercloud.getQuestionsAnswersReducerAsync(Obj));
    } else if (type === 'pageRange') {
      setConfig({
        ...config,
        limitData: (config.limitData = object),
        recordperPage: (config.limitData = object),
        currentPage: 1,
      });
    }
    setTimeout(() => {
      setShowTable(true);
    }, 100);
  };

  const delApplicantJobsCode = useSelector(
    (state) => state.DeleteApplicantJobs.data
  );

  const responseOfQuestionAnswer = useSelector(
    (state) => state.GetQuestionsAnswers.data
  );

  const DeleteRecords = async (object) => {
    if (object.sourcedFrom === 'Cloudsourcing') {
      object['portalassociatedJobs'] = 'csassociatedJobs';
    } else if (object.sourcedFrom === 'Employee Portal') {
      object['portalassociatedJobs'] = 'eassociatedJobs';
    } else if (object.sourcedFrom === 'Vendorsourcing') {
      object['portalassociatedJobs'] = 'vsassociatedJobs';
    } else {
      object['portalassociatedJobs'] = 'associatedJobs';
    }
    object['id'] = object[0].jobopeningID;
    let array = object.map((i) => i.asscoId);
    let deleteIds = { ids: array };
    dispatch(_ser.deleteApplicantJobsAsync(getJobCode, object, deleteIds));
  };

  useEffect(() => {
    if (delApplicantJobsCode === 200) {
      let obj1 = {
        current: config.currentPage,
        offset:
          config.currentPage !== 1
            ? (config.currentPage - 1) * 20 + 1
            : config.currentPage,
      };
      FetchData(obj1);
      dispatch(_ser.deleteApplicantJobsStartReducer(initalState));
    }
  }, [delApplicantJobsCode]);

  useEffect(() => {
    if (responseOfQuestionAnswer && responseOfQuestionAnswer.length > 0) {
      let newObj = JSON.parse(JSON.stringify(responseOfQuestionAnswer));
      newObj.forEach((item) => {
        item.answer = JSON.parse(item.answer);
      });
      setQuestionsData(newObj);
      setIsRightSidePannel(true);
      setComponentType('Questions&Answers');
      dispatch(_sercloud.getQuestionsAnswersStartReducer({}));
    }
  }, [responseOfQuestionAnswer]);

  useEffect(() => {
    console.log(AccociatedJobSeekerList.length > 0);
  }, [showTable, AccociatedJobSeekerList]);

  const onReceivePropsHandler = (pannel, load) => {
    if (load === 'getFetch') {
      setIsRightSidePannel(pannel);
      FetchData();
    } else if (load === 'close') {
      setIsRightSidePannel(pannel);
      setComponentType('AssociatedJobs');
    }
  };

  const storedTheme = JSON.parse(localStorage.getItem('themeSettings')) || '';

  return (
    <>
      {!showJobDetails && !isValidUser ? (
        <>
          <div
            className="adddocumentsection"
            style={{ display: 'flex', height: '34px', gap: '10px' }}
            onClick={() => setIsRightSidePannel(true)}
          >
            {/* <img src={process.env.PUBLIC_URL + "/assests/img/Group 2196.png"} alt="" /> */}
            <DashboardPlusicon width={35} height={36} />
            <h4 className="addnewdocumenttext"> Associate Jobs</h4>
          </div>
        </>
      ) : (
        ''
      )}
      {showJobDetails ? (
        <div id="InnerComponents">
          {/* <PostingsView getData={getData} /> */}
        </div>
      ) : (
        <div className="ApplicantAssociateJobcontentSection">
          {AccociatedJobSeekerList.length > 0 && (
            <DynamicTable
              config={config}
              data={AccociatedJobSeekerList}
              colmns={columnsData}
              actionDropdown={actionsDropdownData}
              actions={actionsList}
              searchKeyWord="Search by Job code, Title"
              noDataText="No associated jobs"
              filterValue={filterValue}
              addModel={addNewModel}
              onReceiveActionProps={(type, obj) =>
                onReceiveActionHandler(type, obj)
              }
            />
          )}
          {AccociatedJobSeekerList.length === 0 && (
            <DynamicTable
              config={config}
              data={AccociatedJobSeekerList}
              colmns={columnsData}
              actionDropdown={actionsDropdownData}
              actions={actionsList}
              searchKeyWord="Search by Job code, Title"
              noDataText="No associated jobs"
              filterValue={filterValue}
              addModel={addNewModel}
              onReceiveActionProps={(type, obj) =>
                onReceiveActionHandler(type, obj)
              }
            />
          )}
        </div>
      )}

      {isRightSidePannel && (
        <AddApplicantAssociatedJobs
          componentType={componentType}
          isRightSidePannel={isRightSidePannel}
          AccociatedJobSeekerList={AccociatedJobSeekerList}
          onPropsReceive={onReceivePropsHandler}
          questionsData={questionsData}
          getData={getData}
          pannelobj={pannelobj}
        />
      )}
    </>
  );
};

export default ApplicantAssociatedApplicants;

const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: true,
  isCheckbox: true,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: '',
  limitData: 10,
  ischeckAlignRight: false,
  isPaginationTop: false,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ['Delete'];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: false,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: 'Job Code',
    mappingName: 'jobCode',
    theadClass: 'text-center dynatableheadtext',
    tbodyClass: 'text-center dynatablebodytext',
    width: '10%',
    isEdit: true,
    nagigate: 'detailspage',
  },
  {
    id: 2,
    displayName: 'Job Title',
    mappingName: 'jobTitle',
    theadClass: 'text-center  dynatableheadtext',
    tbodyClass: 'text-center dynatablebodytext',
    width: '20%',
    isEdit: false,
    nagigate: 'null',
  },
  {
    id: 3,
    displayName: 'Document Name',
    mappingName: 'documentName',
    theadClass: 'text-center  dynatableheadtext',
    tbodyClass: 'text-center dynatablebodytext',
    width: '20%',
    isEdit: false,
    nagigate: 'null',
  },
  {
    id: 4,
    displayName: 'Client',
    mappingName: 'clientName',
    theadClass: 'text-center text-center dynatableheadtext',
    tbodyClass: 'text-center dynatablebodytext',
    width: '20%',
    isEdit: false,
    nagigate: 'null',
  },
  {
    id: 5,
    displayName: 'Last Updated',
    mappingName: 'lastUpdated',
    theadClass: 'text-center text-center dynatableheadtext',
    tbodyClass: 'text-center dynatablebodytext',
    width: '15%',
    isEdit: false,
    nagigate: 'null',
  },
  {
    id: 6,
    displayName: 'Candidate Status',
    mappingName: 'status',
    theadClass: 'text-center text-center dynatableheadtext',
    tbodyClass: 'text-center dynatablebodytext td-flex',
    width: '10%',
    isEdit: false,
    nagigate: 'null',
  },
  {
    id: 7,
    displayName: 'Percentage',
    mappingName: 'percentage',
    theadClass: 'text-center text-center dynatableheadtext',
    tbodyClass: 'text-center dynatablebodytext',
    width: '5%',
    isEdit: false,
    nagigate: 'null',
  },
];

const addNewModel = {
  url: '',
  displayName: '',
};
